import * as m from "@/paraglide/messages";

type Persona = {
	label: string;
	color: "yellow" | "peach";
	rotate: string;
	top?: string;
	right?: string;
	bottom?: string;
	left?: string;
};

const TAG_COLORS = {
	yellow: { bg: "#ffd43b", text: "var(--foreground)" },
	peach: { bg: "#ffb7a3", text: "var(--foreground)" },
} as const;

export function AudienceSection() {
	const personas: Persona[] = [
		{
			label: m.landing_audience_persona1(),
			color: "yellow",
			rotate: "-8deg",
			top: "8%",
			left: "6%",
		},
		{
			label: m.landing_audience_persona2(),
			color: "peach",
			rotate: "8deg",
			top: "8%",
			right: "12%",
		},
		{
			label: m.landing_audience_persona3(),
			color: "peach",
			rotate: "-8deg",
			bottom: "12%",
			left: "8%",
		},
		{
			label: m.landing_audience_persona4(),
			color: "yellow",
			rotate: "8deg",
			bottom: "10%",
			right: "10%",
		},
	];

	return (
		<section className="px-4 py-20 md:px-12 md:py-24">
			<div className="mx-auto max-w-6xl">
				<h2 className="text-balance text-center text-4xl font-semibold leading-tight text-[#272727] md:text-5xl">
					{m.landing_audience_heading1()}
					<br />
					<span className="font-extrabold italic text-primary">
						{m.landing_audience_heading2()}
					</span>{" "}
					{m.landing_audience_heading3()}
				</h2>

				<div className="mt-12 grid grid-cols-1 gap-6 overflow-hidden rounded-[40px] bg-accent p-6 md:grid-cols-[1.2fr_1fr] md:items-center md:p-10">
					<div className="relative h-[420px] overflow-hidden rounded-[28px] md:h-[480px]">
						<img
							src="/images/teacher-photo.jpg"
							alt={m.landing_audience_imageAlt()}
							className="absolute inset-0 size-full object-cover"
							loading="lazy"
						/>
						{personas.map((persona) => {
							const palette = TAG_COLORS[persona.color];
							return (
								<span
									key={persona.label}
									className="absolute inline-flex items-center rounded-[10px] px-4 py-1.5 text-base font-semibold shadow-[0_4px_10px_rgba(0,0,0,0.12)]"
									style={{
										top: persona.top,
										left: persona.left,
										right: persona.right,
										bottom: persona.bottom,
										transform: `rotate(${persona.rotate})`,
										backgroundColor: palette.bg,
										color: palette.text,
									}}
								>
									{persona.label}
								</span>
							);
						})}
					</div>

					<div className="flex flex-col justify-center gap-4 px-2 md:px-4">
						<h3 className="text-3xl font-semibold leading-tight text-foreground">
							{m.landing_audience_subtitle()}
						</h3>
						<p className="text-base leading-relaxed text-[#3a3a52]">
							{m.landing_audience_para1()}
						</p>
						<p className="text-base leading-relaxed text-[#3a3a52]">
							{m.landing_audience_para2()}
						</p>
						<p className="text-base font-semibold leading-relaxed text-[#3a3a52]">
							{m.landing_audience_para3()}
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
